import { useState } from "react"
import { translate } from "../translations/translations"
import {
  getLabelsForAssetType,
  Label,
  validateExpenseForm,
} from "../utils/formHelpers"
import { useCalculator } from "../context/CalculatorContext"

export const useExpenseForm = () => {
  const { shipments, expenses, setExpenses } = useCalculator()
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  const assetType = shipments.assetType
  const labels: Label[] = getLabelsForAssetType(assetType)

  const handleChange = (key: string, value: string) => {
    const numericValue = parseFloat(value)
    const updatedExpenses = { ...expenses.expenses, [key]: numericValue || 0 }
    setExpenses({ ...expenses, expenses: updatedExpenses })

    if (numericValue < 0 || isNaN(numericValue)) {
      setFormErrors((prev) => ({
        ...prev,
        [key]: translate("positive_number_required"),
      }))
    } else {
      setFormErrors({})
    }
  }

  const handleValidation = (): boolean => {
    const { errors, isValid } = validateExpenseForm(expenses.expenses, labels)
    setFormErrors(errors)
    return isValid
  }

  return {
    labels,
    formErrors,
    handleChange,
    handleValidation,
  }
}
